<template>
  <div>
    <div class="flex  flex-col">
      <div class="my-3">
        <span class=" block   text-2xl">Total Payments to Date</span>
        <span class="block font-semibold text-lg">₦ 877,908.50</span>
        <span class="block text-gray-500">12 Receivables</span>
      </div>

      <apexchart
        type="donut"
        width="380"
        :options="chartOptions"
        :series="series"
      >
      </apexchart>
    </div>


  </div>
</template>

<script>
export default {
  data() {
    return {
      series: [30, 50, 10, 10],
      chartOptions: {
        chart: {
          width: 380,
          type: "donut",
        },
        colors: ["#D72638", "#7A90A7", "#09B78A", "#FCC210"],
        dataLabels: {
          enabled: false,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                show: false,
              },
            },
          },
        ],
        legend: {
          position: "right",
          offsetY: 0,
        },
        labels: [
          "Paid Today",
          "Past 7 days",
          "Past 30 days",
          "More than 30 days",
        ],
      },
    };
  },
};
</script>

<style></style>
